import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import { getFacilityTypeLabel } from "@lib/logic";
import type { FacilityResource } from "@lib/store";
import { ModalCellItemIcon } from "@molecules";

type FacilityTypeProps = {
  facilityType: FacilityResource["data"]["facilityType"];
};

// What kind of facility it is, with the type's icon
export const FacilityType = ({ facilityType }: FacilityTypeProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <div className="flex items-center gap-3">
      <ModalCellItemIcon
        className="flex-none"
        backgroundColor={theme.card.beige500.background}
        icon="toilet"
        iconUrl={facilityType.lightIconUrl}
      />
      <p className="font-semibold">{getFacilityTypeLabel(facilityType, t)}</p>
    </div>
  );
};
